var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('el-cascader',{attrs:{"options":_vm.availableAttachments,"clearable":"","filterable":"","placeholder":"请选择物品（可搜索）","props":{ expandTrigger: 'hover' }},model:{value:(_vm.valuesOfNodes),callback:function ($$v) {_vm.valuesOfNodes=$$v},expression:"valuesOfNodes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }